import React, { Component } from "react";
// we need to get into git
import { connect } from "react-redux";
//import axios from "axios";

import QueryDealsBar from "./QueryDealsBar";
import FilterDealsBar from "./FilterDealsBar";

import { getDealSpecials } from "../../actions/dealsActions";
import { queryDeals } from "../../actions/dealsActions";
import { formatSummaryString, formatSummaryCountString } from './DealsDataHelper';

import ErrorMessageConstant from "../common/ErrorMessageConstant";
import LoadingMessage from "../common/LoadingMessage";

import isEmpty from "../common/is-empty";
import DealDisplay from "./DealDisplay";
import DealDisplayDetail from "./DealDisplayDetail";
import DealsMap from "./DealsMap";



class DealsMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deals: [],
      showdetails: false,
      selected_deal: null,
      click_pos: {},
      queryobj: {},
      dofiltering: false,
      fitlerobj: {},
      showmap: false,
      summarystring: 'Last minute deals',
      errors: {}
      // minmax: [50,150], //this.props.location.minMaxData,
      // semillis: [], //this.props.location.startEndMillis,
    };

    //  console.log('props from the slider are ', props);
  }
  componentDidMount() {
    let qobj = {};
    qobj['which'] = 'checkin';
    this.props.getDealSpecials(qobj);
  }
  /*
    componentDidUpdate(prevProps) {
      // Typical usage (don't forget to compare props):
      if (this.props.userID !== prevProps.userID) {
      }
    }
  */



  onQueryDealsSubmit = (obj) => {
    //this.getDeals();
    // this.postDeals(obj);
    // console.log('fbsubmit ', obj);
    // console.log(this.props.deals.delta_start_millis)
    let sumstr = ''; //formatSummaryString(obj);

    this.setState({ queryobj: obj, summarystring: sumstr });
    this.props.queryDeals(obj);
  }


  onSpecialsSubmit = (obj) => {
    let sumstr = 'Last minute deals'; //formatSummaryString(obj);
    if (obj['which'] === 'ppn') {
      sumstr = 'Lowest price per night';

    }
    this.setState({ dofiltering: false, summarystring: sumstr });
    //this.props.wildcardSearchDeals(obj);
    this.props.getDealSpecials(obj);
  }

  showDetailsFromMap = (e, id) => {
    //  console.log('details from map', id);
    let obj = this.props.deals.deals.find((item) => item.id === id);
    this.showDetails(e, obj);
  }

  showDetails = (e, obj) => {
    e.preventDefault();
    let posobj = {};
    posobj['click_y'] = e.pageY;
    posobj['click_x'] = e.pageX;
    this.setState({ showdetails: true, selected_deal: obj, click_pos: posobj });
  }
  onCloseDetail = (e) => {
    e.preventDefault();
    this.setState({ showdetails: false });
  }
  onFilterChange = (obj) => {


    //  console.log(obj);
    if (obj['value'] === 'Any') {
      this.setState({ dofiltering: false });
    } else {
      this.setState({ filterobj: obj, dofiltering: true });
    }
  }

  onShowMap = (obj) => {
    // console.log('onShowMap');
    if (this.state.showmap === true) {
      this.setState({ showmap: false });
    } else {
      this.setState({ showmap: true });
    }
  }


  render() {

    let deals = this.props.deals.deals;
    let { showdetails } = this.state;
    let { selected_deal } = this.state;
    let { click_pos } = this.state;
    let { showmap } = this.state;
    let { queryobj } = this.state;
    let { summarystring } = this.state;
    let { filterobj } = this.state;
    let perrors = this.props.errors;
    let querystring = null;

    // if (formatSummaryString(queryobj).length > 0) {
    //   querystring =
    //     (<div style={{ textAlign: "center" }}>{formatSummaryString(queryobj)}</div>)
    // }
    // if (formatSummaryString(queryobj).length > 0) {
    //   querystring = (
    //     formatSummaryString(queryobj))
    // }

    // let ucities = this.props.deals.current_cities;
    // let ustates = this.props.deals.current_states;
    // let uppn = this.props.deals.current_lok;
    // console.log('filter obj', filterobj);
    // console.log('ucities obj', ucities);
    // console.log('ustates obj', ustates);
    // console.log('uppn obj', uppn);

    let workdeals = deals;
    //  console.log('workdeaks', workdeals);
    //  console.log('filter obj', this.state.filterobj);

    if (this.state.dofiltering) {
      // let ucities = this.props.deals.current_cities;
      // let ustates = this.props.deals.current_states;
      // let uppn = this.props.deals.current_lok;
      // console.log('filter obj', filterobj);
      // console.log('ucities obj', ucities);
      // console.log('ustates obj', ustates);
      // console.log('uppn obj', uppn);
      let which = filterobj['which'];
      let val = filterobj['value'];
      if (which === 'city') {
        workdeals = deals.filter((item) => item.city === val);
      }
      if (which === 'state') {
        workdeals = deals.filter((item) => item.state === val);
      }
      if (which === 'lok') {
        workdeals = deals.filter((item) => item.accommodations['lok'] === parseInt(val));
      }

    } else {
      // console.log(' filtering reset filter obj', filterobj);

    }
    // console.log('workdeaks after filtering', workdeals);

    // console.log('workdeals are', workdeals);

    let template = workdeals.map((deal, index) => (
      <div key={index}>
        <DealDisplay
          deal={deal}
          showDetails={this.showDetails}
        />
      </div>
    ));
    // if (!minmax) return (<div></div>);
    // removed from query deals bar onSearchSubmit={this.onSearchSubmit} 

    let errmsg = '';
    if (!isEmpty(perrors)) {
      errmsg = perrors['message']
    }
    if (workdeals.length === 0) {
      errmsg = 'No deals found.  Please refine your filter/query parameters';
    }

    let sumstr = formatSummaryCountString(queryobj, workdeals.length);
    if (summarystring.length > 0) {
      sumstr = summarystring;
    }
    return (
      <div
        className="xcontainer"
        style={{ border: "0px solid black", marginTop: "0px" }}
      >
        <div id='dealdisplaydetailsdiv'>
          {showdetails ? (
            <DealDisplayDetail
              deal={selected_deal}
              onClose={this.onCloseDetail}
              click_pos={click_pos}
            />
          ) : (null)}
        </div>
        <div className="jumbotron_ld" style={{ paddingTop: "10px" }}>

          <QueryDealsBar onQueryDealsSubmit={this.onQueryDealsSubmit}
            onSpecialsSubmit={this.onSpecialsSubmit} />

          <FilterDealsBar onFilterChange={this.onFilterChange} onShowMap={this.onShowMap} />
          {(this.props.deals.isloading) ? (<LoadingMessage />) : null}
          <div className="summarydisplay">{sumstr}</div>
          {(errmsg.length > 0) ? (<ErrorMessageConstant message={errmsg} />) : null}

          {!showmap ? (<div className="flex_base">
            {template}
          </div>) : (
              <div className="mapdisplay" style={{ width: "95%", margin: "10px auto" }}>
                <div>
                  <div style={{ width: "310px", float: "left", height: "715px", overflowY: "scroll" }}>
                    {template}
                  </div>
                  <div >
                    <DealsMap workdeals={deals} showDetailsFromMap={this.showDetailsFromMap} />
                  </div>
                </div>
                {/* <div className="row">
                  <div className="col-md-3">
                    <div style={{ height: "715px", overflowY: "scroll" }}>
                      {template}
                    </div>
                  </div>
                  <div className="col-md-9">
                    <DealsMap workdeals={workdeals} showDetailsFromMap={this.showDetailsFromMap} />
                  </div>
                </div> */}
              </div>
            )}

        </div>

      </div >
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  deals: state.deals,
  errors: state.errors,
});

export default connect(mapStateToProps, { queryDeals, getDealSpecials })(DealsMain);

//export default Dashboard;

/*
<div className="xjumbotron_ld" >
          {showmap ? (<span>showmap</span>) : (<span>hide map</span>)}

          {querystring}
        </div>
        */



// WEBPACK FOOTER //
// ./src/components/deals/DealsMain.js